import { request1, request } from '../utils/request'
import { stringify } from '../utils/index'
import Vue from 'vue'

const Api = {
  getcenterauditgoods: (option) => request1('v1/points/exchangecentergoods/getcenterauditgoods', option), // 产品中心-商品列表

  getservicecategorys2: option => request('v1/servicecata/getservicecategorys2', option), // 机构服务产品
  deleteservicecategory: (option) => request('v1/servicecata/deleteservicecategory' + stringify(option), option), // 删除机构服务产品
  addservicecategory: (option) => request('v1/servicecata/addservicecategory', option), // 新增机构服务产品
  updateservicecategory: (option) => request('v1/servicecata/updateservicecategory', option), // 新增机构服务产品

  getservs: option => request('v1/serv/getservs', option), // 服务产品列表
  getserv: option => request('v1/serv/getserv' + stringify(option), option), // 获取服务产品
  deleteserv: option => request('v1/serv/deleteserv' + stringify(option), option), // 服务产品删除
  addserv: option => request('v1/serv/addserv', option), // 新增服务产品
  updateserv: option => request('v1/serv/updateserv', option), // 修改服务产品

  getservorgs: option => request('v1/servorg/getservorgs', option), // 服务机构列表
  getservorg: option => request('v1/servorg/getservorg' + stringify(option, true), option), // 获取服务机构
  deleteservorg: option => request('v1/servorg/deleteservorg' + stringify(option, true), option), // 服务机构删除
  addservorg: option => request('v1/servorg/addservorg', option), // 新增服务机构
  updateservorg: option => request('v1/servorg/updateservorg', option), // 修改服务机构

  getstaffs: option => request('v1/sysstaff/getstaffs', option), // 查询人员列表
  addstaff: option => request('v1/sysstaff/addstaff', option), // 新增人员
  updatestaff: option => request('v1/sysstaff/updatestaff', option), // 修改人员
  deletestaff: option => request('v1/sysstaff/deletestaff' + stringify(option, true), option), //  删除人员

  getservconsults: option => request('v1/servconsult/getservconsults', option, true), // 需求列表
  getservconsult: option => request('v1/servconsult/getservconsult' + stringify(option), option), // 获取需求
  deleteservconsult: option => request('v1/servconsult/deleteservconsult' + stringify(option), option), // 需求删除
  addservconsult: option => request('v1/servconsult/addservconsult', option), // 新增需求
  updateservconsult: option => request('v1/servconsult/updateservconsult', option) // 修改需求
}

Vue.prototype.$$OrgService = Api

export default Api
